import React, { useState } from "react";
import Header from "../Header/Header";
import { useMediaQuery } from "react-responsive";
import OutlinedCard from "../Card/mobCard";
import "./HomePage.css";

function TSH() {
  const [loading, setLoading] = useState(true);
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1024px)" });

  const handleIframeLoad = () => {
    setLoading(false);
  };

  return (
    <>
      {isDesktopOrLaptop ? (
        <div className="App">
          <div style={{ zIndex: 1000, position: "sticky", top: 0 }}>
            <Header />
          </div>
          <div className="iframe-container">
            {loading && (
              <div className="loader">Loading...</div>
            )}
            <iframe
              src="https://www.dartstech.com/widgets/top-stock-history.aspx?custid=28"
              title="Top Stock Report"
              frameBorder="0"
              allowFullScreen
              onLoad={handleIframeLoad}
              style={{ display: loading ? "none" : "block" }}
            ></iframe>
          </div>
        </div>
      ) : (
        <OutlinedCard />
      )}
    </>
  );
}

export default TSH;
